import { useSearch } from '@tanstack/react-router';

/** The post id named by `?post=`, when present -- the scope a caller reaches
 *  the assistant with from that post's own screen (73-2-07's 'Perguntar sobre
 *  esta publicação'). */
export function useAssistantPostId(): string | null {
  const { post } = useSearch({ strict: false }) as Record<string, unknown>;
  return typeof post === 'string' && post !== '' ? post : null;
}
